import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/home/Home.vue'
import Merchant from '@/router/merchant.js';
import UserCenter from '@/router/userCenter.js';
import ProductDetail from "@/router/productDetail";
import BusinessEnter from './businessEnter'
import About from './about'

Vue.use(Router);

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        {
          path: '',
          name: 'home',
          meta: {
            title: '首页'
          },
          component: () => import('@/views/home/HomeContain.vue')
        },
        {
          path: '/productlist',
          name: 'productlist',
          meta: {
            title: '产品列表'
          },
          component: () => import('@/views/productDetail/ProductList.vue')
        },
        ...ProductDetail,
        {
          path: '/financingplan',
          name: 'financingplan',
          meta: {
            title: '我要融资'
          },
          component: () => import('@/views/financingPlan/FinancingPlan.vue')
        },
        {
          path: '/appointmentvisit',
          name: 'appointmentvisit',
          meta: {
            title: '预约参观'
          },
          component: () => import('@/views/productDetail/appointmentVisit.vue')
        },
        {
          path: '/entirebuy',
          name: 'entirebuy',
          component: () => import('@/views/entireBuy/EntireBuy.vue')
        },
        {
          path: '/appointmentsuccess',
          name: 'appointmentsuccess',
          meta: {
            title: '预约参观成功'
          },
          component: () => import('@/views/productDetail/appointmentSuccess.vue')
        },
        ...Merchant,
        ...UserCenter,
        {
          path: '/asktobuy',
          name: 'asktobuy',
          meta: {
            title: '发布需求'
          },
          component: () => import('@/views/askToBuy/AskToBuy.vue')
        },
        {
          path: '/show',
          name: 'show',
          meta: {
            title: '展会列表'
          },
          component: () => import('@/views/show/Show.vue')
        },
        {
          path: '/show/detail',
          name: 'showdetail',
          meta: {
            title: '展会详情'
          },
          component: () => import('@/views/show/ShowDetail.vue')
        },
        ...BusinessEnter,
        ...About,
        {
          path: '/newdetail',
          name: 'newdetail',
          meta: {
            title: '新闻详情'
          },
          component: () => import('@/views/newList/NewDetail.vue')
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录'
      },
      component: () => import('@/views/Login/Login.vue')
    },
    {
      path: '/register',
      name: 'register',
      meta: {
        title: '注册'
      },
      component: () => import('@/views/Register/Register.vue')
    },
    {
      path: '/modifymessage',
      name: 'modify',
      meta: {
        title: ''
      },
      component: () => import('@/views/userCenter/myShop/ModifyMessage.vue')
    }
  ],
  scrollBehavior(to, from, savedPosition) { //设置页面的滚动
    if(to.name === 'productlist' && to.query){
      return false;
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js